import { useTranslation } from 'react-i18next';
import house from '../../assets/house_about_us.svg';
import classes from './About.module.css';
import Seo from '../../components/Seo.tsx';

export default function About() {
    const { t } = useTranslation();

    const seoTitle = t('seo.aboutTitle');
    const seoDescription = t('seo.aboutDescription');

    return (
        <>
            <Seo title={seoTitle} description={seoDescription} canonicalPath="/about" type="article" />
            <div className={classes.about}>
                <div className={classes.aboutInner}>
                    <div className={classes.text}>
                        <span style={{ lineHeight: "1" }} className={classes.title}>promociones montosa</span>
                        {/* <span className={classes.title}>Sobre nosotros</span> */} {/* uncomment when full page ready */}
                        <p>{t('about_page_text')}</p>
                    </div>
                    <img alt='house' src={house} className={classes.houseImage} />
                </div>
                <div className={classes.contact}>
                    <span><span className={classes.promonsaFont}>{t('address')}: </span>Avenida de la Hispanidad, 20, BAJO, 18320 Santa Fe (Granada), Spain</span>
                    <span><span className={classes.promonsaFont}>{t('email')}: </span>info@promonsa.net</span>
                    <span><span className={classes.promonsaFont}>{t('phone')}: </span>+34 653 78 45 11</span>
                </div>
            </div>
        </>
    );
}
